module.exports = __webpack_public_path__ + "static/images/styles/images/nations/france.27f0bf1b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/france.png
// module id = 3662
// module chunks = 11